import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";

import { UnifiedDataTable } from "../../../layout/unified-data-table/ui/unified-data-table";
import type { UnifiedTableRecord } from "../../../shared/ui/data-table/model/data-table-contract";

import * as Styled from "./insurance.styled";

interface IPatientInfoOutletContext {
  setIsStretchContent: React.Dispatch<React.SetStateAction<boolean>>;
}

const insuranceRecord: UnifiedTableRecord = {
  module: "insurance",
  pageTitle: "Insurance",
  sections: [
    {
      id: "insurance",
      title: "Insurance",
      tables: [
        {
          id: "insurance-table",
          columns: [
            { key: "rank", header: "Rank", sortable: true },
            { key: "carrier", header: "Carrier", sortable: true },
            { key: "groupNumber", header: "Group #", sortable: true },
            { key: "planNumber", header: "Plan #", sortable: true },
            { key: "enrollment", header: "Enrollment", sortable: true },
            {
              key: "terminationDate",
              header: "Termination Date",
              sortable: true,
            },
            {
              key: "subscriberFirstName",
              header: "Subscriber First Name",
              sortable: true,
            },
            {
              key: "subscriberMi",
              header: "Subscriber MI",
              sortable: true,
            },
            {
              key: "subscriberLastName",
              header: "Subscriber Last Name",
              sortable: true,
            },
            {
              key: "subscriberDob",
              header: "Subscriber DOB",
              sortable: true,
            },
          ],
          rows: [
            {
              rank: "1",
              carrier: "Priority Health Medicare",
              groupNumber: "10003",
              planNumber: "80029745900",
              enrollment: "-",
              terminationDate: "-",
              subscriberFirstName: "Evonne",
              subscriberMi: "A",
              subscriberLastName: "Kok",
              subscriberDob: "12/05/1945",
            },
            {
              rank: "1",
              carrier: "Florida Blue",
              groupNumber: "999996F 101",
              planNumber: "XJNH85569 635",
              enrollment: "-",
              terminationDate: "-",
              subscriberFirstName: "Gilbert",
              subscriberMi: "-",
              subscriberLastName: "Gust Jr",
              subscriberDob: "02/20/1948",
            },
          ],
          ui: {
            searchable: true,
            searchPlaceholder: "Search...",
            searchKeys: [
              "rank",
              "carrier",
              "groupNumber",
              "planNumber",
              "enrollment",
              "terminationDate",
              "subscriberFirstName",
              "subscriberMi",
              "subscriberLastName",
              "subscriberDob",
            ],
            downloadable: ["csv", "xls", "pdf"],
            showTableDownloads: true,
            defaultRowsPerPage: 10,
            rowsPerPageOptions: [5, 10, 20, 25],
          },
        },
      ],
    },
  ],
};

export const Insurance = () => {
  const outletContext = useOutletContext<
    IPatientInfoOutletContext | undefined
  >();
  const setIsStretchContent = outletContext?.setIsStretchContent;
  const contentScrollerRef = React.useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!setIsStretchContent) {
      return;
    }

    setIsStretchContent(true);

    return () => {
      setIsStretchContent(false);
    };
  }, [setIsStretchContent]);

  return (
    <Styled.Container>
      <Styled.Title>Insurance</Styled.Title>
      <UnifiedDataTable
        record={insuranceRecord}
        useSharedSectionNav
        scrollContainerRef={contentScrollerRef}
      />
    </Styled.Container>
  );
};
